import React, { useEffect, useState } from "react"
import { Icon } from "@iconify/react/dist/iconify.js"
import {
  connectGoogleCalendar,
  fetchGoogleCalendarTokens,
  deleteGoogleCalendarToken,
} from "../utils/requests/calendar"

const CalendarSettingsLayer = () => {
  const [loading, setLoading] = useState(true)
  const [loadingTokens, setLoadingTokens] = useState(false)
  const [googleTokens, setGoogleTokens] = useState([])

  const handleConnectGoogleCalendar = () => {
    const clientId =
      "1085055399421-9b8badu8u5hsvor8vj21751fk5ll2hdi.apps.googleusercontent.com"
    const redirectUri = "https://desk.diodrive.co.il/calendar-settings"
    const scopes = [
      "https://www.googleapis.com/auth/calendar",
      "https://www.googleapis.com/auth/userinfo.email",
      "https://www.googleapis.com/auth/userinfo.profile",
    ]
    const scopeString = scopes.join(" ")
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scopeString}&access_type=offline&prompt=consent`

    window.location.href = authUrl
  }

  // Handle OAuth Redirect
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get("code")
    const redirect = urlParams.get("redirect")

    if (redirect) {
      handleConnectGoogleCalendar()
    }

    if (code) {
      connectGoogleCalendar(code).then(() => {
        window.location.replace("/calendar-settings?done=true")
      })
    } else {
      setLoading(false)
    }
  }, [])

  const fetchTokens = async () => {
    setLoadingTokens(true)
    try {
      const fetchedTokens = await fetchGoogleCalendarTokens()
      setGoogleTokens(fetchedTokens)
    } catch (error) {
      console.error("Failed to fetch tokens:", error)
    } finally {
      setLoadingTokens(false)
    }
  }

  useEffect(() => {
    fetchTokens()
  }, [])

  const onDeletePress = async (tokenId) => {
    try {
      await deleteGoogleCalendarToken(tokenId)
      await fetchTokens()
    } catch (error) {
      console.error("Failed to delete token:", error)
    }
  }

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "400px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">טוען...</span>
        </div>
      </div>
    )
  }

  return (
    <div className="row gy-4">
      <div className="col-12">
        <div className="card h-100 p-0">
          <div className="card-header border-bottom bg-base py-16 px-24">
            <h6 className="text-lg fw-semibold mb-0">הגדרות יומן</h6>
          </div>
          <div className="card-body p-24">
            <div className="tokens-list">
              <h2 className="text-xl fw-semibold mb-16">סנכרון ליומן חיצוני</h2>

              {loadingTokens ? (
                <div className="d-flex justify-content-center align-items-center py-32">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">טוען...</span>
                  </div>
                </div>
              ) : googleTokens.length === 0 ? (
                <div className="text-center py-32">
                  <div className="mb-16">
                    <Icon
                      icon="solar:calendar-outline"
                      className="text-6xl text-secondary-light"
                    />
                  </div>
                  <p className="text-secondary-light mb-16">
                    אין חשבונות מקושרים
                  </p>
                  <button
                    onClick={handleConnectGoogleCalendar}
                    className="btn border-primary-500 radius-8 px-20 py-11 d-flex align-items-center gap-2 mx-auto text-primary"
                  >
                    <Icon icon="logos:google-icon" className="text-xl" />
                    חבר יומן גוגל
                  </button>
                </div>
              ) : (
                <div className="accounts-list">
                  {googleTokens.map((token) => (
                    <div key={token.id} className="card mb-16 border">
                      <div className="card-body p-16">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-3">
                            <div className="w-48-px h-48-px bg-primary-50 rounded-circle d-flex align-items-center justify-content-center">
                              <Icon
                                icon="logos:google-icon"
                                className="text-xl text-primary-600"
                              />
                            </div>
                            <div>
                              <h6 className="mb-0 fw-semibold">
                                {token.userName}
                              </h6>
                              <p className="mb-0 text-sm text-secondary-light">
                                {token.email}
                              </p>
                            </div>
                          </div>
                          <button
                            onClick={() => onDeletePress(token.id)}
                            className="btn btn-outline-danger-600 radius-8 px-16 py-8"
                          >
                            <Icon
                              icon="solar:trash-bin-trash-outline"
                              className="text-lg"
                            />
                            מחיקה
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="text-center mt-24">
                    <button
                      onClick={handleConnectGoogleCalendar}
                      className="btn border-primary-500 radius-8 px-20 py-11 d-flex align-items-center gap-2 mx-auto text-primary"
                    >
                      <Icon icon="logos:google-icon" className="text-xl" />
                      חבר יומן גוגל
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CalendarSettingsLayer
